// extracted by mini-css-extract-plugin
export default {"action":"PersonalisedMenteeEmailersManageConfirmButton_action__EOQYH"};